import ApolloClient, {ApolloLink, gql, HttpLink, InMemoryCache} from 'apollo-boost'
import {query} from 'svelte-apollo';

import {Observable, from, of} from "rxjs";
import {mergeMap, map, toArray, tap, filter} from "rxjs/operators";
import {createHttpLink} from "apollo-link-http";

let client = undefined;
const url = "https://ngdev.iotreno.com/graphql";

function execQuery(query_string) {
    let observable;

    if (client === undefined) {
        observable = new Observable(subscriber => {

            firebase.auth().currentUser.getIdToken().then(token => {
                if (token !== "") {
                    client = new ApolloClient({
                        uri: "https://ngdev.iotreno.com/graphql",
                        headers: {
                            "x-firebase-jwt": token,
                        },
                    });
                    subscriber.next(client);
                    subscriber.complete();
                } else {
                    client = undefined;
                }
            })

        });
    } else {
        observable = of(client);
    }

    return observable.pipe(
        mergeMap(gqlClient => {
            return new Observable(subscriber => {
                query(gqlClient, {query: gql(query_string)})
                    .subscribe(promise => {
                        subscriber.next(promise);
                        subscriber.complete();
                    })
            }).pipe(mergeMap(promise => from(promise)));
        })
    );
}

/**
 * @param: {string} params.client: URL of the graphql endpoint
 * @param {boolean} params.sort: Sort the messages by date
 * @param {boolean} params.array: Return the observable as an array, or each item as an event
 * @param {boolean} params.messages: Add all messages
 * @returns {Observable<unknown>}
 */
export function get_sensors(params) {
    let messagesGQL =  `
        messages {
            date
            value
        }
    `;

    let GQL = `
{
    findSensorsByMyOrganization {
        id
        name
        type
        category
        units
        ${params.messages ? messagesGQL : ""}
        lastMessage {
            id
            sensorId
            value
            display
            battery
            signal
            voltage
            date
        }
        gatewayId
    }
}
`;

    return execQuery(GQL).pipe(
        map(data => data.data.findSensorsByMyOrganization),
        mergeMap(sensors => from(sensors)),
        map(sensor => {
            if (params.sort)
                sensor.messages = sensor.messages.sort((a, b) => new Date(a.date) - new Date(b.date));
            return sensor;
        }),
        params.array ? toArray() : tap()
    )
}

/**
 * @param {boolean} params.sort: Sort the messages by date
 * @returns {Observable<Sensor>}
 */
export function get_sensor(params) {
    const GQL = `
query {
  findSensorById(input: {id: "${params.id}"}) {
    id
    name
    type
    category
    units
    calibration
    lastMessage {
      id
      sensorId
      value
      display
      date
    }
    messages {
      value
      date
    }
    vendor
    gatewayId
    updatedAt
    createdAt
  }
}
`;

    return execQuery(GQL).pipe(
        map(data => data.data.findSensorById),
        map(data => {
            if (params.sort) data.messages = data.messages.sort((a, b) => new Date(a.date) - new Date(b.date));
            return data;
        })
    );
}

/**
 * @param {boolean} params.sort Sort the messages by date
 * @params {boolean} params.messages Includes messages or not
 * @param {int} params.id Id of the sensor to get
 * @returns {Observable<Sensor>}
 */
export function get_sensor_id(params) {
    // let messagesGQL = params.messages ? gql(`
    //     messages {
    //         date
    //         value
    //     }
    // `) : "";

    const GQL = `
query {
  findSensorById(input: {id:"${params.id}"}){
    id
    name
    type
    category
    units
    calibration
    lastMessage {
      id
      sensorId
      value
      display
      date
      battery
      signal
      voltage
    }
    messages {
      date
      value
    }
    vendor
    gatewayId
    updatedAt
    createdAt
  }
}
`;
    return execQuery(GQL).pipe(
        map(data => data.data.findSensorById),
        map(data => {
            if (params.sort) data.messages = data.messages.sort((a, b) => new Date(a.date) - new Date(b.date));
            return data;
        })
    );
}

/**
 *
 * @param params
 * @returns {Observable<unknown>>}
 */
export function get_sensor_messages(params) {
    let GQL = `
    {
        findSensorById(input: {id:"${params.id}"}){
            id
            messages {
                date
                value
                display
            }
        }
    }`;

    return execQuery(GQL).pipe(
        map(data => data.data.findSensorById),
    )
}

export function get_organizations(){
    let GQL = `
    {
      findOrganizations {
        id
        name
      }
    }`;

    return execQuery(GQL).pipe(
        map(data => data.findOrganizations)
    )
}